import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  procedimientos: [],
  fetchProcedimientosLoading: false,
  fetchProcedimientosError: null,

  procedimiento: {},
  fetchProcedimientoLoading: false,
  fetchProcedimientoError: null,

  addProcedimientoLoading: false,
  addProcedimientoError: null,

  updateProcedimientoLoading: false,
  updateProcedimientoError: null,

  deleteProcedimientoLoading: false,
  deleteProcedimientoError: null
};

export const procedimientosSlice = createSlice({
  name: 'PROCEDIMIENTOS',
  initialState,
  reducers: {
    fetchProcedimientosStart: state => {
      state.fetchProcedimientosLoading = true;
      state.fetchProcedimientosError = null;
    },
    fetchProcedimientosSuccess: (state, action) => {
      state.fetchProcedimientosLoading = false;
      state.procedimientos = action.payload;
    },
    fetchProcedimientosError: (state, action) => {
      state.fetchProcedimientosLoading = false;
      state.fetchProcedimientosError = action.payload;
    },

    fetchProcedimientoStart: state => {
      state.fetchProcedimientoLoading = true;
      state.fetchProcedimientoError = null;
    },
    fetchProcedimientoSuccess: (state, action) => {
      state.fetchProcedimientoLoading = false;
      state.procedimiento = action.payload;
    },
    fetchProcedimientoError: (state, action) => {
      state.fetchProcedimientoLoading = false;
      state.fetchProcedimientoError = action.payload;
    },

    addProcedimientoStart: state => {
      state.addProcedimientoLoading = true;
      state.addProcedimientoError = null;
    },
    addProcedimientoSuccess: (state, action) => {
      state.addProcedimientoLoading = false;
      state.procedimientos.push(action.payload);
    },
    addProcedimientoError: (state, action) => {
      state.addProcedimientoLoading = false;
      state.addProcedimientoError = action.payload;
    },

    updateProcedimientoStart: state => {
      state.updateProcedimientoLoading = true;
      state.updateProcedimientoError = null;
    },
    updateProcedimientoSuccess: (state, action) => {
      state.updateProcedimientoLoading = false;
      const newArray = state.procedimientos.map(proc => {
        if (proc.id === action.payload.id) return action.payload;
        return proc;
      });
      state.procedimientos = newArray;
    },
    updateProcedimientoError: (state, action) => {
      state.updateProcedimientoLoading = false;
      state.updateProcedimientoError = action.payload;
    },

    deleteProcedimientoStart: state => {
      state.deleteProcedimientoLoading = true;
      state.deleteProcedimientoError = null;
    },
    deleteProcedimientoSuccess: (state, action) => {
      state.deleteProcedimientoLoading = false;
      const newArray = state.procedimientos.filter(
        proc => proc.id !== action.payload.id
      );
      state.procedimientos = newArray;
    },
    deleteProcedimientoError: (state, action) => {
      state.deleteProcedimientoLoading = false;
      state.deleteProcedimientoError = action.payload;
    }
  }
});

export const {
  fetchProcedimientosStart,
  fetchProcedimientosSuccess,
  fetchProcedimientosError,
  fetchProcedimientoStart,
  fetchProcedimientoSuccess,
  fetchProcedimientoError,
  addProcedimientoStart,
  addProcedimientoSuccess,
  addProcedimientoError,
  updateProcedimientoStart,
  updateProcedimientoSuccess,
  updateProcedimientoError,
  deleteProcedimientoStart,
  deleteProcedimientoSuccess,
  deleteProcedimientoError
} = procedimientosSlice.actions;

export default procedimientosSlice.reducer;
